import React from "react";

// Sitemap links ko array me store karte hain
const sitemapLinks = [
  { title: "Home", url: "https://www.isolsgroup.com/" },
  { title: "Contact Us", url: "/contact" },
  { title: "Innovative Solution Technologies", url: "/innovative-solution-technologies" },
  { title: "Digital India Leader", url: "/digital-india-leader" },
  { title: "Digital Marketing Companion", url: "/digital-marketing-companion" },
  { title: "Book You Online", url: "/book-you-online" },
  { title: "Top Business Technology Solutions & Services", url: "/business-technology-solutions" },
  { title: "Best Digital Marketing Services Company in Gurgaon, Delhi, Noida India", url: "/digital-marketing-solutions" },
  { title: "Digital Payment Solutions", url: "/digital-payment-solutions" },
  { title: "Top Business Process Outsourcing BPO Services & Solutions", url: "/business-process-management" },
  { title: "Cloud Infrastructure Service", url: "/cloud-infra-solutions" },
  { title: "Tech & Digital Consulting Services", url: "/technology-digital-consulting" },
  { title: "Tech & Digital Solutions Marketing For Healthcare & Medical Industry", url: "/healthcare-medical-solutions" },
  { title: "Travel & Hospitality Tech Digital Solutions", url: "/travel-hospitality-solutions" },
  { title: "Media & Publishing", url: "/publishing" },
  { title: "eCommerce & Retail", url: "/ecommerce-retail-solutions" },
  { title: "Banking & Fintech", url: "/banking-finance-solutions" },
  { title: "Manufacturering & Tech", url: "/manufacturing-industry-solutions" },
  { title: "Government & Public Sector", url: "/government-publicsector-solutions" },
  { title: "About ISOLS Group", url: "/about-isolsgroup" },
  { title: "Awards & Certifications", url: "/award-certifications" },
  { title: "Careers", url: "/careers" },
  { title: "Life @ISOLS Group", url: "/vibrant-culture" },
  { title: "CSR", url: "/csr" },
  { title: "Media & Press Release", url: "/media-releases" },
  { title: "Investor Relations", url: "/investor-relations" },
  { title: "Clients Testimonial", url: "/testimonial" },
  { title: "Clients", url: "/clients" },
  { title: "Thirsty Hunter", url: "/thirsty-hunter" },
  { title: "Privacy Policy", url: "/privacy-policy" },
  { title: "Refund Policy", url: "/refund-policy" },
  { title: "DMCA ISOLS Group", url: "/dmca-Policy" },
  { title: "Sitemap", url: "/sitemap" },
  { title: "Best SEO services in india", url: "/search-engine-optimization" },
  { title: "Best Social Media Marketing Agency in India", url: "/social-media-marketing" },
  { title: "ORM services in Gurgaon", url: "/online-reputation-management" },
  { title: "PPC Services in Gurgaon", url: "/pay-per-click" },
  { title: "Influencer Marketing", url: "/influencer-marketing" },
  { title: "Digital India Leader", url: "/digitalindialeader" },
  { title: "Our Influencer Network", url: "/influencer-network" },
];

const Sitemap = () => {
  return (
    <div className="page-container" id="missionidd">
      {/* Breadcrumbs */}
      <div
        className="breadcrumbs-header paralax"
        style={{
          backgroundImage: "url('https://www.isolsgroup.com/images/header/about-isols.jpg')",
          backgroundSize: "contain",
          backgroundPosition: "0% 0%",
        }}
      >
        <ul className="half-filter">
          <li className="dark-filter relative">
            <h1 className="pull-right color-1 text-right"><b>Sitemap</b></h1>
            <ul className="breadcrumbs pull-right">
              <li><a href="https://www.isolsgroup.com/">home</a></li>
              <li><span className="separate">/</span></li>
              <li><span>Sitemap</span></li>
            </ul>
            <div className="cutBox cut-bottom"></div>
          </li>
          <li className="custom-filter"></li>
        </ul>
      </div>

      {/* Sitemap links */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12">
              <div className="b-mod-heading wow fadeInDown">
                <h2 className="termm">Explore Our Website Structure</h2>
                <ul className="stlist">
                  {sitemapLinks.map((link, index) => (
                    <li className="lpage" key={index}>
                      <a href={link.url} title={link.title}>{link.title}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sitemap;
